(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-menu"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Node)) return;
    for (const menu of document.querySelectorAll('details.bf-seasonal-menu[open]')) {
      if (!menu.contains(event.target)) menu.removeAttribute('open');
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;
    const menu = event.target.closest('details.bf-seasonal-menu[open]');
    if (!menu) return;
    menu.removeAttribute('open');
    menu.querySelector('summary')?.focus();
  });
  } catch(e) { console.error(e); }
})();

})();
